/** חילוץ מזהה מועד מציון */
export function resolveGradePeriodId(grade) {
  const p = grade.examPeriodId?._id ?? grade.examPeriodId;
  return p ? String(p) : null;
}

/** סינון ציונים למועד ספציפי */
export function filterGradesForPeriod(grades, periodId) {
  if (!periodId) return [];
  const pid = String(periodId);
  return (grades || []).filter((g) => resolveGradePeriodId(g) === pid);
}

/** תווית תצוגה לציון בודד */
export function formatGradeLabel(grade, isGemara) {
  if (isGemara || grade.tractate) {
    return grade.tractate || grade.examId?.name || '—';
  }
  const code = grade.examId?.code;
  const name = grade.examId?.name || '';
  if (code != null) return `[${code}] ${name}`.trim();
  return name || '—';
}

/** בניית מחרוזת סיכום + מערך פריטים לתצוגה */
export function formatMemberGradesSummary(grades, { isGemara = false } = {}) {
  const items = (grades || []).map((g) => ({
    label: formatGradeLabel(g, isGemara),
    score: g.score,
  }));
  const summary = items.map(({ label, score }) => `${label}: ${score}`).join(' · ');
  return { summary, items };
}

/** מיפוי memberId → { _gradesSummary, _grades } לפי מועד */
export function buildMemberGradesMap(grades, periodId, { isGemara = false } = {}) {
  const filtered = filterGradesForPeriod(grades, periodId);
  const byMember = {};
  for (const g of filtered) {
    const mid = String(typeof g.memberId === 'object' ? g.memberId?._id : g.memberId);
    if (!mid || mid === 'undefined') continue;
    if (!byMember[mid]) byMember[mid] = [];
    byMember[mid].push(g);
  }
  const result = {};
  for (const [mid, memberGrades] of Object.entries(byMember)) {
    result[mid] = formatMemberGradesSummary(memberGrades, { isGemara });
  }
  return result;
}
